import { render, staticRenderFns } from "./game-month-rounds.vue?vue&type=template&id=f89c8c1a&scoped=true"
import script from "./game-month-rounds.vue?vue&type=script&lang=js"
export * from "./game-month-rounds.vue?vue&type=script&lang=js"
import style0 from "./game-month-rounds.vue?vue&type=style&index=0&id=f89c8c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89c8c1a",
  null
  
)

export default component.exports